import { useCallback } from 'react';
import { useUrlFilters } from '@/lib/hooks/useUrlFilters';
import type { BillFilters, BillState } from '../types';

const defaults: BillFilters = {
  s: undefined,
  limit: 10,
  page: 0,
  orderBy: 'updatedAt',
  order: 'desc',
  'createdAt.min': undefined,
  'createdAt.max': undefined,
  'dueAt.min': undefined,
  'dueAt.max': undefined,
  state: undefined,
  type: undefined,
  clientId: undefined,
  contractId: undefined,
};

const numberFields: (keyof BillFilters)[] = ['limit', 'page', 'clientId', 'contractId'];

export function useBillFilters() {
  const { updateFilter, ...rest } = useUrlFilters<BillFilters>({ defaults, numberFields });

  const setState = useCallback(
    (state: BillState | undefined) => updateFilter('state', state, true),
    [updateFilter]
  );

  const setSearch = useCallback(
    (search: string) => updateFilter('s', search || undefined, true),
    [updateFilter]
  );

  return { ...rest, updateFilter, setState, setSearch };
}
